import React from "react";
import { Link } from "react-router-dom";
import "../Styles/wedding-services-section.css";

export default function WeddingServicesSection() {
  return (
    <section className="wedding-services-container">
      <div className="wedding-services-card">
        <h2 className="wedding-services-title">
          Register your local Wedding Services!
        </h2>

        <p className="wedding-services-description">
          Showcase your wedding-related services, including photography, makeup,
          boutiques, mehndi, decor, catering, jewellery, and more. Register on
          WedLuk without any investment and reach brides, grooms, parents, and
          agents in your community and nearby regions.
        </p>

        <p className="wedding-services-description">
          WedLuk connects you with people actively planning their weddings and
          looking for trusted local experts. Add your business details to become
          discoverable to users seeking reliable, community-based wedding
          services. Grow your business, strengthen your reputation, and support
          the people around you.
        </p>

        <Link
          to="/business-network-coming-soon"
          className="wedding-services-link"
        >
          Build your page now ❯
        </Link>
      </div>
    </section>
  );
}
